import React from "react";
import constants from "../utils/constants";

export function ArrowDown({ style, fontSize, ...rest }) {
  return (
    <ion-icon
      name="arrow-down-circle-outline"
      style={{
        color: constants.PRIMARY,
        fontSize: fontSize || 14,
        ...style,
      }}
      {...rest}
    ></ion-icon>
  );
}

export function ArrowUp({ style, fontSize, ...rest }) {
  return (
    <ion-icon
      name="arrow-up-circle-outline"
      style={{
        color: "red",
        fontSize: fontSize || 14,
        ...style,
      }}
      {...rest}
    ></ion-icon>
  );
}
